import React from 'react'

export const Pagination = ({currentPage, changeCurrentPage, darkmode}) => {
    let is_first_page = currentPage === 1 ? true : false;
    currentPage = currentPage > 1 ? currentPage : 1;
    
    const handlePageClick = (e, page) => {
        e.preventDefault();
        changeCurrentPage(page);
    };
    
    return (
        <div className={`pagination-container ${darkmode ? 'dark' : ''}`}>
            <nav aria-label="Page navigation">
                <ul className="pagination justify-content-center">
                    <li className="page-item">
                        <a 
                            className="page-link" 
                            href="#" 
                            aria-label="Previous" 
                            onClick={e => handlePageClick(e, currentPage - 1)}
                        >
                            <span aria-hidden="true">&laquo;</span>
                            <span className="sr-only">Previous</span>
                        </a>
                    </li>
                    <li className={`page-item ${is_first_page ? 'active' : ''}`}>
                        <a 
                            href="#" 
                            className="page-link" 
                            onClick={e => handlePageClick(e, is_first_page ? currentPage : currentPage - 1)}
                        >
                            {is_first_page ? currentPage : currentPage - 1}
                        </a>
                    </li>
                    <li className={`page-item ${!is_first_page ? 'active' : ''}`}>
                        <a 
                            href="#" 
                            className="page-link" 
                            onClick={e => handlePageClick(e, is_first_page ? currentPage + 1 : currentPage)}
                        >
                            {is_first_page ? currentPage + 1 : currentPage}
                        </a>
                    </li>
                    <li className="page-item">
                        <a 
                            href="#" 
                            className="page-link" 
                            onClick={e => handlePageClick(e, is_first_page ? currentPage + 2 : currentPage + 1)}
                        >
                            {is_first_page ? currentPage + 2 : currentPage + 1}
                        </a>
                    </li>
                    <li className="page-item">
                        <a 
                            className="page-link" 
                            href="#" 
                            aria-label="Next" 
                            onClick={e => handlePageClick(e, currentPage + 1)}
                        >
                            <span className="sr-only">Next</span>
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Pagination;
